// src/router/index.tsx
import { lazy, Suspense } from "react";
import { Switch, Route, useLocation, matchPath } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
    color: '#666'
  }}>
    Loading...
  </div>
);

const noLayoutPaths = routes
  .filter((r) => r.noLayout)
  .flatMap((r) => (Array.isArray(r.path) ? r.path : [r.path]));

const Router = () => {
  const location = useLocation();
  const hideLayout = noLayoutPaths.some((p) =>
    matchPath(location.pathname, { path: p, exact: true })
  );

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Styles />
      {!hideLayout && <Header />}
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(
                /* webpackChunkName: "[request]" */
                `../pages/${routeItem.component}`
              ))}
            />
          );
        })}
      </Switch>
      {!hideLayout && <Footer />}
    </Suspense>
  );
};

export default Router;
